import FingerprintPattern from 'lucide-react/dist/esm/icons/fingerprint-pattern.mjs';
import ShieldCheck from 'lucide-react/dist/esm/icons/shield-check.mjs';
import { BrandMark } from './components/BrandMark.jsx';
import { ErrorDialog, SuccessDialog } from './components/Dialogs.jsx';
import { ApprovalSection, FeatureSection, FinalCta } from './components/PageSections.jsx';
import { SubscribeButton } from './components/SubscribeButton.jsx';
import { useSubscriptionFlow } from './useSubscriptionFlow.js';

export default function App() {
  const {
    status,
    flow,
    dialog,
    loadingStatus,
    subscribe,
    deactivate,
    closeDialog,
  } = useSubscriptionFlow();
  const active = Boolean(status?.subscription?.active);

  return (
    <div className="app-shell" id="top">
      <header className="site-header section-shell">
        <BrandMark />
        <nav aria-label="Основная навигация">
          <a href="#features">Возможности</a>
          <a href="#how-it-works">Как это работает</a>
          <a href="#terms">Условия</a>
        </nav>
      </header>

      <main>
        <section className="hero section-shell" aria-labelledby="hero-title">
          <div className="hero__copy">
            <h1 id="hero-title">
              <span>Спокойный</span>
              <span>интернет —</span>
              <span>одним касанием.</span>
            </h1>
            <p className="hero__lead">
              <span>Блокирует фишинг и опасные сайты,</span>
              <span>защищает публичный Wi‑Fi</span>
              <span>и предупреждает об утечках.</span>
            </p>

            <div className="hero__price" aria-label="Стоимость 20 рублей в день">
              <strong>20 ₽</strong>
              <span>/ день</span>
            </div>

            <SubscribeButton
              active={active}
              flow={flow}
              onClick={subscribe}
              location="hero"
            />

            <div className="passkey-helper">
              <FingerprintPattern aria-hidden="true" />
              <span>Подтверждение через Touch ID, Face ID или код устройства</span>
            </div>

            <div className="hero__terms">
              <span className="demo-notice">
                <ShieldCheck aria-hidden="true" />
                Демо‑режим: деньги не списываются
              </span>
              <span>Автопродление ежедневно. Отмена в любой момент.</span>
            </div>
          </div>

          <div className="hero__visual" aria-hidden="true">
            <img src="/assets/bolt-protect-orb.webp" alt="" fetchPriority="high" />
          </div>
        </section>

        <FeatureSection />
        <ApprovalSection />
        <FinalCta active={active} flow={flow} onSubscribe={subscribe} />
      </main>

      <footer className="site-footer section-shell">
        <BrandMark compact />
        <p>Демонстрационный интерфейс. Реальная услуга и списания отсутствуют.</p>
        <span>WebAuthn / Passkey POC</span>
      </footer>

      <div className="sr-only" role="status" aria-live="polite">
        {loadingStatus
          ? 'Проверяем состояние демо-подписки'
          : flow.phase === 'requesting'
            ? 'Ожидается системное подтверждение на устройстве'
            : active
              ? 'Демо-подписка активна'
              : 'Демо-подписка не активна'}
      </div>

      <SuccessDialog
        dialog={dialog}
        onClose={closeDialog}
        onDeactivate={deactivate}
        busy={flow.phase === 'deactivating'}
      />
      <ErrorDialog dialog={dialog} onClose={closeDialog} />
    </div>
  );
}
